var animateCircle = (function () {
    var canvas = document.getElementById('circle-15m');
    if (canvas) {
        var counterBlock = document.getElementById('circle-counter'),
            countN = 0,
            context = canvas.getContext('2d'),
            x = canvas.width / 2,
            y = canvas.height / 2,
            radius = 141,
            endPercent = 25,
            curPerc = 0,
            circ = Math.PI * 2,
            quart = Math.PI / 2,
            self = {};

        context.lineWidth = 8;

        self.animate = function (current) {
            context.clearRect(0, 0, canvas.width, canvas.height);

            context.beginPath();
            context.strokeStyle = '#d92626';
            context.arc(x, y, radius, -(quart), ((circ) * current) - quart, false);
            context.stroke();
            curPerc++;
            if (curPerc < endPercent) {
                requestAnimationFrame(function () {
                    self.animate(curPerc / 100)
                });
            }
            context.closePath();

            context.beginPath();
            context.strokeStyle = 'rgba(85,85,85,0.38)';
            context.arc(x, y, radius, ((circ) * current) - quart, 3 * Math.PI / 2, false);
            context.stroke();

            counterTime();
        };

        function counterTime() {
            if (countN <= 15) {
                counterBlock.innerHTML = countN;
                countN++;
            }
        }

        return self;
    }
})();